import { useHandleFetchError } from "../../../error-handler";
import { useGetCountries } from "../../../service/api";
import { SelectInput } from "./SelectInput";

type Props = {
  name: string;
};

export const SelectLocaleInput = ({ name }: Props) => {
  const { data: countries, error: getCountriesError } = useGetCountries();

  const enabledCountries = new Set(
    countries?.filter((c) => c.enabled).map((c) => c.countryCode)
  );

  const locales = new Map([
    ["DK", { label: "🇩🇰 Danish", value: "da" }],
    ["FR", { label: "🇫🇷 French", value: "fr" }],
    ["NL", { label: "🇳🇱 Dutch", value: "nl" }],
    ["SE", { label: "🇸🇪 Swedish", value: "sv" }],
    ["NO", { label: "🇳🇴 Norwegian", value: "nb" }],
    ["IS", { label: "🇮🇸 Icelandic", value: "is" }],
    ["DE", { label: "🇩🇪 German", value: "de" }],
  ]);

  const localeOptions = Array.from(enabledCountries)
    .sort((a, b) => a.localeCompare(b))
    .filter((o) => locales.has(o))
    .map((o) => ({
      label: locales.get(o)?.label || o,
      value: locales.get(o)?.value || o,
    }));

  localeOptions.unshift({
    label: "🇬🇧 English",
    value: "en",
  });

  localeOptions.unshift({
    label: "None",
    value: "",
  });

  useHandleFetchError(getCountriesError);

  return (
    <SelectInput
      name={name}
      label="Locale"
      options={localeOptions}
      placeholder="Choose locale"
    />
  );
};
